import { render } from "./Dashboard3.vue?vue&type=template&id=ae4be67c&scoped=true"
import script from "./Dashboard3.vue?vue&type=script&lang=js"
export * from "./Dashboard3.vue?vue&type=script&lang=js"

import "./Dashboard3.vue?vue&type=style&index=0&id=ae4be67c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae4be67c"]])

export default __exports__